import { render, staticRenderFns } from "./DepReviewComponents.vue?vue&type=template&id=7b865fb8&"
import script from "./DepReviewComponents.vue?vue&type=script&lang=js&"
export * from "./DepReviewComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports